import React from "react";
import { GridColumnMenuFilter } from "@progress/kendo-react-grid";

export default function GridFilterColumnMenu(props) {
    return <div>
        <GridColumnMenuFilter {...props} expanded={true} />
    </div>;
}